// extracted by mini-css-extract-plugin
export var deleteIcon = "_rm-5";
export var deleteOption = "_rm-3";
export var divider = "_rm-2";
export var downloadIcon = "_rm-4";
export var drawer = "_rm-0";
export var drawerFooter = "_rm-6";
export var drawerOpen = "_rm-1";
export var highlighted = "_rm-7";
export var lighterHighlight = "_rm-8";